import type {
  EventCatalogEntry,
  EventCatalogPrice,
} from "@repo/vihangam-yog-shared";
import {
  DONATION,
  findEventEntry,
  HEARD_ABOUT_US_OPTIONS,
} from "@repo/vihangam-yog-shared";

/** The event this site is built around. Tiers, add-ons, date and venue all come from the shared catalog, never from this package. */
const EVENT_SLUG = "hawan-yajna-sep-19";

export const CONTACT_EMAIL = "info@vyaustralia.org";

export interface PricedEvent extends EventCatalogEntry {
  price: EventCatalogPrice;
}

export interface BookingConfig {
  event: PricedEvent;
  donation: typeof DONATION;
  referrals: typeof HEARD_ABOUT_US_OPTIONS;
}

/** Reads the Yajna out of the shared catalog; throws at build time if it ever stops being a priced event. */
export function loadBookingConfig(): BookingConfig {
  const event = findEventEntry(EVENT_SLUG);
  if (!event?.price) {
    throw new Error(
      `${EVENT_SLUG} is not a priced event in the shared catalog; this site has nothing to sell`,
    );
  }
  return {
    event: { ...event, price: event.price },
    donation: DONATION,
    referrals: HEARD_ABOUT_US_OPTIONS,
  };
}
